import React from 'react'
import Header from './header'
import './lane2.css'

const Lane = ({ icon, title, actions = [], children, className }) => {
    
    const iconBtn = typeof icon === 'object' ? icon : { icon }

    return (
        <div className="lane2">
            <Header icon={ iconBtn } title={title} >
                {actions}
            </Header>
            <main className={className}>
                {children}
            </main>
        </div>
    )
}

export default Lane;



// WEBPACK FOOTER //
// ./src/lib/components/lane2.js